import React from "react"
import adminRoute from "./admin";
import dealerRoute from "./dealer";

import {PlatformType} from "../utils/constants";
import ProductDetail from "../pages/product-detail";
import {withRouter} from "react-router";
import Suit from "../pages/suit";
import SuitDetail from "../pages/suit-detail";
import SalesOrder from "../pages/sales-order";
import PresaleOrder from "../pages/presale-order";
import RefundOrder from "../pages/rerurn-order";
import ConsignOrder from "../pages/consign-order";
import SalesOrderDetail from "../pages/sales-order-detail";
import PresaleOrderDetail from "../pages/presale-order-detail";
import ConsignOrderDetail from "../pages/consign-order-detail";
import Contract from "../pages/contract";
import ContractEdit from "../pages/contract-edit";
import Sample from "../pages/sample";
import Rebate from "../pages/rebate";
import CalcProportion from "../pages/sample-calc-proportion";
import RebateDetail from "../pages/rebate-detail";
import RangeProportion from "../pages/sample-range-proportion";
import SampleDealerQuota from "../pages/sample-dealer-quota";
import SampleDealerQuotaDetail from "../pages/sample-dealer-quota-detail";
import SampleCalcProportionDetail from "../pages/sample-calc-proportion-detail";
import RebateSummary from "../pages/rebate-summary";
import RebateTransactions from "../pages/rebate-transactions";

import RefundOrderDetail from "../pages/return-order-detail";
import PresaleOrderLine from "../pages/presale-order-line";
import ConsignOrderLine from "../pages/consign-order-line";


const ProductCategory = React.lazy(() => import('../pages/product-category'));
const Product = React.lazy(() => import('../pages/product'));

const routes: Routes = {
    '/product/product/:id':{
        component: withRouter(ProductDetail),
    },
    '/product/category': {
        component: ProductCategory
    },
    '/product/product':{
        component: Product
    },
    '/product/suit/detail/:id?':{
        component: withRouter(SuitDetail)
    },
    '/product/suit/add':{
        component: withRouter(SuitDetail)
    },
    '/product/suit':{
        component: Suit
    },
    '/order/sales/detail/:id':{
        component: withRouter(SalesOrderDetail)
    },
    '/order/sales':{
        component: SalesOrder
    },
    '/order/presaleLines':{
        component: PresaleOrderLine
    },
    '/order/presale/detail/:id':{
        component: withRouter(PresaleOrderDetail)
    },
    '/order/presale':{
        component: PresaleOrder
    },
    '/order/stockoutLines':{
        component: PresaleOrderLine
    },
    '/order/stockout/detail/:id':{
        component: withRouter(PresaleOrderDetail)
    },
    '/order/stockout':{
        component: PresaleOrder
    },
    '/order/return/detail/:id': {
        component: RefundOrderDetail
    },
    '/order/return': {
        component: RefundOrder
    },
    '/order/consignLines':{
        component: ConsignOrderLine
    },
    '/order/consign/detail/:id':{
        component: withRouter(ConsignOrderDetail)
    },
    '/order/consign':{
        component: ConsignOrder
    },
    '/contract/contract/add/': {
        component: withRouter(ContractEdit)
    },
    '/contract/contract/detail/:id?': {
        component: withRouter(ContractEdit)
    },
    '/contract/contract/version/:id': {
        component: withRouter(ContractEdit)
    },
    '/contract/contract/': {
        component: Contract
    },
    '/sample/rangeProportion':{
        component: RangeProportion
    },
    '/sample/calcProportion/detail/:id':{
        component: withRouter(SampleCalcProportionDetail)
    },
    '/sample/calcProportion':{
        component: CalcProportion
    },
    '/sample/sample':{
        component: Sample
    },
    '/sample/dealerQuota/detail/:id':{
        component: withRouter(SampleDealerQuotaDetail)
    },
    '/sample/dealerQuota':{
        component: SampleDealerQuota
    },
    '/rebate/transactions':{
        component: RebateTransactions
    },
    '/rebate/summary':{
        component: RebateSummary
    },
    '/rebate/rebate/detail/:id':{
        component: withRouter(RebateDetail)
    },
    '/rebate/rebate/add':{
        component: withRouter(RebateDetail)
    },
    '/rebate/rebate':{
        component: Rebate
    }
}


routes.platforms = {
    [PlatformType.Admin]: adminRoute,
    [PlatformType.Dealer]: dealerRoute,
}
routes.flat = function (platform): Route {
    const {platforms = {}, ...mainRoutes} = this;
    return {...mainRoutes, ...platforms[platform]};
}


export default routes
